import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IBaseSearchRequest, IPagedResults } from 'src/app/core/models/base';
import { environment } from 'src/environments/environment';
import { ICreateWorkTimeRequest, ICreateWorkTimeResponse, ISearchWorkTimes, IUpdateWorkTimeRequest, IUpdateWorkTimeResponse, IWorkTime } from '../models/work-time';

@Injectable({
  providedIn: 'root'
})
export class WorkTimeService {

  constructor(private http: HttpClient) { }



  searchWorkTimes(request: ISearchWorkTimes){
    return this.http.post<IPagedResults<IWorkTime[]>>(
      `${environment.baseUrl}/v1/workTime/searchworkTimes`,
      request
    )
  }

  createWorkTime(request : ICreateWorkTimeRequest){
    return this.http.post<ICreateWorkTimeResponse>(
      `${environment.baseUrl}/v1/workTime/createworkTime`,
      request
    )
  }

  updateWorkTime(request : IUpdateWorkTimeRequest){
    return this.http.put<IUpdateWorkTimeResponse>(
      `${environment.baseUrl}/v1/workTime/updateworkTime/${request.id}`,
      request
    )
  }

  deleteWorkTime(id :string){
    return this.http.delete(
      `${environment.baseUrl}/v1/workTime/deleteworkTime/${id}`
    )
  }
}
